// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>20</span>&nbsp;&nbsp;To you, O my strength, will I sing;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for you, O God, are my refuge,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;my God of steadfast love.<br> </p> </div></div>";
// Exports
module.exports = code;